import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, sortingOptions1 } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import { ConfigProvider, Pagination } from "antd";
import StaffItemComponent from "../component/StaffItemComponent";
import AddStaffModal from "../component/modals/AddStaffModal";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import ViewStaffModal from "../component/modals/ViewStaffModal";
import ChangeStaffBranchModal from "../component/modals/ChangeStaffBranchModal";
import moment from "moment";
import CustomLoader from "../component/menu/CustomLoader";
import { Spin } from "antd";
import DataNotFound from "../component/common/DataNotFound";
import { staffStatusList } from "../services/mixed-service";
import TableHeaderComponent from "../component/TableHeaderComponent";
import { getRestaurantId } from "../utils/authUtils";

function Staff() {
  const { user, branches, restaurantId, restaurantName, setNetworkCall, showNotification } = useUserStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [changeBranchModal, setChangeBranchModal] = useState(false);
  const [viewStaffModal, setViewStaffModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [action, setAction] = useState();
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [staffs, setStaffs] = useState(null);

  const [total, setTotal] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState({
    restaurantId: restaurantId,
    status: "On",
    sortBy: "NEWEST",
    page: 1,
    perPage: 10,
    searchText: "",
  });

  const branchOptions = branches.map((branch) => ({
    value: branch.slug, // Unique identifier
    label: `${branch.name}-${branch.branch}`, // Combine restaurant name and branch
  }));
  const [isStaffLoading, setIsStaffLoading] = useState(true);

  const onClickAddButton = (value) => {
    setIsModalOpen(value);
  };

  const onClickSaveButtonInModal = async (response) => {
    fetchStuffList();

    setIsModalOpen(response.showModal);
  };

  const onClickOkForViewStaffModal = async () => {
    setIsEditMode(false);
    setViewStaffModal(false);
    if (isEditMode) {
      await fetchStuffList();
    }
  };

  const onClickCancelForViewStaffModal = async () => {
    setIsEditMode(false);
    setViewStaffModal(false);
  };

  const onClickCancelButtonInModal = () => {
    setIsModalOpen(false);
  };
  const onSelectStaff = (val, action) => {
    switch (action) {
      case constants.STAFF.CHANGE: {
        setSelectedItem(val);
        // setViewStaffModal(true)
        setChangeBranchModal(true);
        break;
      }
      case constants.STAFF.VIEW: {
        setSelectedItem(val);
        setViewStaffModal(true);
        break;
      }
      case constants.STAFF.EDIT: {
        setSelectedItem(val);
        setIsEditMode(true);
        setViewStaffModal(true);
        break;
      }
      case constants.STAFF.ON: {
        setConfirmationMessage(`Are you sure you want to <b>Avtive</b> staff <b>${val.name}</b>?`);
        setSelectedItem(val);
        setAction(constants.STAFF.ON);
        setIsConfirmModalOpen(true);
        break;
      }
      case constants.STAFF.OFF: {
        setConfirmationMessage(`Are you sure you want to <b>Inactive</b> staff <b>${val.name}</b>?`);
        setSelectedItem(val);
        setAction(constants.STAFF.OFF);
        setIsConfirmModalOpen(true);
        break;
      }
      case constants.STAFF.DELETE: {
        setConfirmationMessage(`Are you sure want to delete staff <b>${val.name}</b>?`);
        setSelectedItem(val);
        setAction(constants.STAFF.DELETE);
        setIsConfirmModalOpen(true);
        break;
      }
    }
  };
  const onConfirm = (record, action) => {
    staffStatusChange(record, action);
    setIsConfirmModalOpen(false);
  };

  const staffStatusChange = async (record, action) => {
    try {
      const status = action !== constants.STAFF.DELETE ? 0 : 1;
      setNetworkCall(true);
      const response = await ApiService.STAFF_STATUS_CHANGE(
        {
          restaurantId,
          staffId: record._id,
          retire: status,
        },
        user.token.token
      );

      fetchStuffList();
      showNotification("Status changed successfully.", false);
    } catch (error) {
      showNotification("Failed to change status. Please, reload and try again.");
    } finally {
      setNetworkCall(false);
    }
  };

  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  const fetchStuffList = async (args = null) => {
    const actualFilter = args || filter;
    setIsStaffLoading(true);
    const params = { ...actualFilter, restaurantId: getRestaurantId() }; // It will guarantee that restaurant id will be available at init fetching

    await ApiService.FILTER_STUFF_LIST(params, user.token.token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        return;
      }

      let newStaffs = [];

      res.payload.staffs.map((stuff) => {
        if (!res || (res && res.code !== 200)) {
          return;
        }

        const staff = stuff.restaurants.find((item) => item.restaurantId === restaurantId);

        // Hiding logged-in user from staff list
        if (stuff._id === user.id) return;

        newStaffs.push({
          _id: stuff._id,
          branchName: restaurantName ? restaurantName.match(/\(([^)]+)\)/)?.[1] || "" : "",
          order_id: 1,
          name: staff.staffName || stuff.name,
          position: staff?.staffPosition ?? "",
          contact: `0${stuff.phone}`,
          gender: stuff.gender,
          econtact: `${stuff.emergencyContactNumber} (${stuff.emergencyContactName})`,
          econ: stuff?.emergencyContactNumber ?? "",
          econ_name: stuff?.emergencyContactName ?? "",
          address: stuff.address,
          day: "Sat - Thu",
          time: "14:00 ~ 23:00",
          dob: stuff?.dob ? moment(stuff.dob).format("YYYY-MM-DD") : "",
          restaurants: stuff.restaurants,
          status: staff.status,
        });
      });

      setStaffs(newStaffs);
      setTotal(res.payload.pagination.total);
      setIsStaffLoading(false);
    });
  };

  const handleBranchChangeFinish = async (params) => {
    setChangeBranchModal(false);
    fetchStuffList();
  };

  const handleBranchChangeCancel = () => {
    setChangeBranchModal(false);
  };

  const onSearchText = (value) => {
    const tmpFilter = { ...filter, page: 1, searchText: value };
    setFilter(tmpFilter);
    fetchStuffList(tmpFilter);
  };

  const onSortRecord = (value) => {
    const tmpFilter = { ...filter, page: 1, sortBy: value };
    setFilter(tmpFilter);
    fetchStuffList(tmpFilter);
  };

  const onPageChange = (page) => {
    const tmpFilter = { ...filter, page };
    setFilter(tmpFilter);
    fetchStuffList(tmpFilter);
  };

  const onHandleChangeStatus = (val) => {
    const tmpFilter = { ...filter, page: 1, status: val };

    setFilter(tmpFilter);
    fetchStuffList(tmpFilter);
  };

  useEffect(() => {
    fetchStuffList();
  }, []);

  return (
    <div className="flex flex-col font-uregular">
      <Header title={`McDonalds Food Chain`} menu={constants.MENU.STAFF} currentMenuKey={"T_5_S_5"} />
      <CustomLoader />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.STAFF} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <TableHeaderComponent
              searchText={searchText}
              setSearchText={setSearchText}
              sortingOptions={sortingOptions1}
              onChangeSorting={onSortRecord}
              enabledFilters={["FILTER11"]}
              record={{
                title: "All Staffs",
                hint: "Search in Staffs",
                callback: onClickAddButton,
                search: onSearchText,
                filter11: {
                  isLableNeeded: false,
                  value: filter.status,
                  options: staffStatusList,
                  fieldClass: "w-[100px]",
                  onHandleChangeFilter11: onHandleChangeStatus,
                },
              }}
            />
            <div className="flex flex-col">
              {isStaffLoading ? (
                <div className="h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : staffs?.length > 0 ? (
                staffs.map((item, index) => (
                  <div key={index}>
                    <StaffItemComponent record={item} callback={onSelectStaff} />
                  </div>
                ))
              ) : (
                <DataNotFound />
              )}
            </div>
            <div className="flex flex-row justify-start">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={total}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={filter.perPage}
                  defaultCurrent={filter.page}
                  current={filter.page}
                  onChange={onPageChange}
                  showSizeChanger={false}
                />
              </ConfigProvider>
            </div>
          </div>
          <ChangeStaffBranchModal
            openModal={changeBranchModal}
            records={{
              brancheOptions: branchOptions,
              selectedItem: selectedItem,
              onFinish: handleBranchChangeFinish,
              onCancel: handleBranchChangeCancel,
            }}
          />

          <AddStaffModal
            openModal={isModalOpen}
            records={{
              onFinish: onClickSaveButtonInModal,
              onCancel: onClickCancelButtonInModal,
            }}
          />
          <ViewStaffModal
            openModal={viewStaffModal}
            records={{
              onFinish: onClickOkForViewStaffModal,
              onCancel: onClickCancelForViewStaffModal,
              isEditMode: isEditMode,
              param: selectedItem,
            }}
          />
          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              message: confirmationMessage,
              param: selectedItem,
              action: action,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Staff;
